<div class="content-card">

    <app-notification-popup 
    [isVisible]="isNotificationPopupOpen"
    (close)="closeNotificationPopup()"
    [errorMessage]="errorMessage()"
    [secondErrorMessage]="secondErrorMessage()"
    ></app-notification-popup>

    <div class="benchmark-container" >
      <div class="msg-container" *ngIf="!isModelDataVisible()">
        <span class="default-msg">{{ emptyModuleMessage() }}</span>
      </div>

        <div class="table-container" *ngIf="isModelDataVisible()">

            <p-table [value]="benchmarkRows()" 
            [responsiveLayout]="'scroll'" 
            [scrollable]="true" 
            [scrollHeight]="'calc(100vh - 340px)'"
            scrollDirection="horizontal"
            class="results-table"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of benchmarkColumns(); let i = index" 
                  [ngClass]="{'frozen-column': i === 0}" 
                  class="custom-column">
                    <div class="column-header-container">
                      <div class="header-title">{{ col.header }}</div>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td *ngFor="let col of benchmarkColumns(); let i = index" 
                    class="{{ row.dataCategory.toLowerCase() }}-row"
                    [ngClass]="getCellClasses(row, col, i)"
                  pTooltip="{{ getTooltipText(row, col, i) }}">
                  <ng-container *ngIf="i === 0">
                    <span class="bullet"><fa-icon [icon]="['fas', 'circle']"></fa-icon></span>
                  </ng-container>
                    {{ i === 0 ? row[col.field] : (row[col.field] | number:'1.0-2') }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

    </div>

    <div class="dropdown-container" *ngIf="isModelDataVisible()">
        <div class="top-block">
          <div class="selection-block">
            <label>Select scenario:</label>
            <p-select [options]="scenarioDropdown()" 
            [(ngModel)]="selectedScenario" 
            optionLabel="description" 
            (onChange)="onScenarioChange($event)"></p-select>
          </div>
          <div class="scope-flag-block">
            <div class="msg-container {{ flagClassName() }}-msg-container" *ngIf="isFlagVisible()">
              <span class="icon"><fa-icon [icon]="faSnowflake"></fa-icon></span>
              <span class="msg {{ flagClassName() }}-msg">{{ flagMessage() }}</span>
            </div>
          </div>
        </div>
        <div class="color-references-container" *ngIf="rowsCategories().length > 0">
            <div class="color-references-title">Table references</div>
              <ng-container *ngFor="let category of rowsCategories()">
                  <div class="bullet-container {{ category }}-row">
                    <span class="bullet"><fa-icon [icon]="['fas', 'circle']"></fa-icon></span>
                      <span class="category-text">{{ category }}</span>
                  </div>
              </ng-container>
        </div>
    </div>
</div>

